export enum components40Names {
    ROOM_LAYOUT = 'room-layout',
    HTML_NODE = 'html',
	FIELDS_SECTION = 'fields-section',
    MAP = 'map-location',
    RULES = 'inline-rules',
    TABS_SECTION = 'tabs-section',
	TABS_SECTION_BUTTON = 'tabs-section-button',
    PHOTO_GALLERY = 'photo-gallery',
    PANORAMA_TOUR = '3d-tour',
    RESOURCE_MEDIA = 'resource-media-control',
    PHOTO_SELECTED = 'photo-selected',
	PHOTO_BULK_DELETE = 'photo-bulk-delete',
    SMARTTAGS_LIST = 'smart-tags-list',
    SINGLE_IMAGE = 'single-image',
    PROPERTY_DATA = 'property-data',
	GENERAL_ORDER_DATA = 'general-order-data'
}
